import React from 'react';
import { styled } from '@mui/material/styles';
import { Modal as MuiModal } from '@mui/material';

// NOTE: There needs to be a better patterm as we break
// multiple components on small iphone devices on edge cases.
const StyledMuiModal = styled(MuiModal)({
  height: '100vh',
  display: 'flex',
  flexDirection: 'column',
  width: '100%',
  padding: '1rem',
  overflow: 'hidden',
  alignItems: 'center',
  alignContent: 'center',
  justifyContent: 'center',
});

/**
 * @typedef {Omit<React.ComponentProps<typeof MuiModal>, 'open'> & {
 *  isOpen: boolean;
 * }} StyledModalProps
 */

/**
 * @param {StyledModalProps} props
 * @returns {JSX.Element}
 */
const StyledModal = ({ isOpen = false, children, sx, ...props }) => (
  <StyledMuiModal
    data-testid="default-styled-mui-modal"
    open={isOpen}
    closeAfterTransition
    sx={{
      overflow: 'scroll',
      height: '100vh',
      ...sx,
    }}
    // eslint-disable-next-line react/jsx-props-no-spreading
    {...props}
  >
    {children}
  </StyledMuiModal>
);

export default StyledModal;
